export default __webpack_public_path__ + "static/media/laboralty.3e51cd46.png";